import DimensiHeadSuper from "../../../../../components/categories/siakad/laporan_adab/penilaian/HomeHeadSuper";
export default function Home() {
  
  return (
    <DimensiHeadSuper />
  );
}
